import { jwtDecode } from 'jwt-decode'

export function decodeProfileToken(profileToken: string) {
  return jwtDecode(profileToken)
}

export default decodeProfileToken
